import React from "react";
import { cn } from "@/lib/utils";
// Bundled as a hashed asset by Vite so it always loads from our own origin. The
// previous external https://www.eigenify.com/images/eigenify-logo.png 404'd, showing
// a broken-image box on the login screen.
import eigenifyLogo from "@/assets/eigenify-logo.png";

interface LogoProps {
  size?: number;
  className?: string;
}

export function Logo({ size = 64, className }: LogoProps) {
  return (
    <img
      src={eigenifyLogo}
      alt="Eigenify"
      width={size}
      height={size}
      className={cn("dark:brightness-0 dark:invert transition-all", className)}
      style={{ height: size, width: "auto" }}
    />
  );
}






